import React, { useState, useEffect } from "react";
import { Heart } from "lucide-react";
import { useAuth } from "../AuthContext";
import { API_URL } from "../config";

export default function LikeButton({ contentType, contentId, onLoginRequest }) {
  const { isLoggedIn, token } = useAuth();
  const [liked, setLiked] = useState(false);
  const [count, setCount] = useState(0);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    fetch(`${API_URL}/likes/status?content_type=${contentType}&content_id=${contentId}`, { headers })
      .then(r => r.ok ? r.json() : { liked: false, count: 0 })
      .then(d => { setLiked(d.liked); setCount(d.count); })
      .catch(() => {});
  }, [contentType, contentId, token]);

  const toggle = async () => {
    if (!isLoggedIn) { onLoginRequest && onLoginRequest(); return; }
    setBusy(true);
    try {
      const r = await fetch(`${API_URL}/likes/toggle`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ content_type: contentType, content_id: contentId }),
      });
      if (r.ok) {
        const d = await r.json();
        setLiked(d.liked);
        setCount(d.count);
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <button onClick={toggle} disabled={busy} style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      background: liked ? "#fee2e2" : "#f0f2f8", color: liked ? "#c0392b" : "#555",
      border: "none", borderRadius: 8, padding: "6px 14px", fontSize: "0.9rem",
      fontWeight: 600, cursor: "pointer", marginTop: 0,
    }}>
      <Heart size={15} strokeWidth={2.2} fill={liked ? "#c0392b" : "none"} /> {count > 0 ? count : ""}
    </button>
  );
}
